import { watchEffect as i } from "vue";
import { m as d } from "./focus-management-uTsAyIu4.js";
function m({ container: e, accept: r, walk: l, enabled: t }) {
  i(() => {
    let a = e.value;
    if (!a || t !== void 0 && !t.value) return;
    let c = d(e);
    if (!c) return;
    let n = Object.assign((f) => r(f), { acceptNode: r }), o = c.createTreeWalker(a, NodeFilter.SHOW_ELEMENT, n, !1);
    for (; o.nextNode(); ) l(o.currentNode);
  });
}
export {
  m as p
};
//# sourceMappingURL=use-tree-walker-AStIFPaK.js.map
